import React from 'react';
import { CreditCard, Download, FileText, Heart, Link2, LogOut } from 'lucide-react';
import { usePwaInstall } from '../../../hooks';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '../../ui/dropdown-menu';

function getInitials(name) {
  if (!name) return 'U';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return parts[0][0].toUpperCase();
}

function ProfileTrigger({ name }) {
  return (
    <div className="mx-auto flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground">
      {getInitials(name)}
    </div>
  );
}

export default function HeaderProfileMenu({
  user,
  signOut,
  onJoin,
  onBadgeOpen,
  onMyPlan,
  onOpenDetails,
  hasFormDetails,
  showMyPlan,
  variant = 'full'
}) {
  const { canOfferInstall, promptInstall } = usePwaInstall();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-none bg-transparent p-0 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
        <ProfileTrigger name={user?.displayName} />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-64">
        <div className="border-b border-border/50 p-3">
          <p className="font-medium text-foreground">{user?.displayName}</p>
          <p className="text-sm text-muted-foreground">{user?.email}</p>
        </div>

        {variant === 'welcome' ? (
          <>
            <DropdownMenuItem onClick={onJoin} className="cursor-pointer">
              <Link2 className="mr-2 h-4 w-4" />
              Join
            </DropdownMenuItem>
            {canOfferInstall && (
              <DropdownMenuItem onClick={promptInstall} className="cursor-pointer">
                <Download className="mr-2 h-4 w-4" />
                Install app
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={signOut} className="cursor-pointer text-destructive">
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </>
        ) : (
          <>
            {showMyPlan && (
              <>
                <DropdownMenuItem onClick={onMyPlan} className="cursor-pointer">
                  <CreditCard className="mr-2 h-4 w-4" />
                  My Plan
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}

            <DropdownMenuItem onClick={onJoin} className="cursor-pointer">
              <Link2 className="mr-2 h-4 w-4" />
              Join
            </DropdownMenuItem>

            <DropdownMenuItem onClick={onBadgeOpen} className="cursor-pointer">
              <Heart className="mr-2 h-4 w-4" />
              Interests
            </DropdownMenuItem>

            {hasFormDetails && (
              <DropdownMenuItem onClick={onOpenDetails} className="cursor-pointer">
                <FileText className="mr-2 h-4 w-4" />
                My Details
              </DropdownMenuItem>
            )}

            {canOfferInstall && (
              <DropdownMenuItem onClick={promptInstall} className="cursor-pointer">
                <Download className="mr-2 h-4 w-4" />
                Install app
              </DropdownMenuItem>
            )}

            <DropdownMenuSeparator />

            <DropdownMenuItem onClick={signOut} className="cursor-pointer text-destructive">
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
